import { render } from "./index.vue?vue&type=template&id=2a13bbe7&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=2a13bbe7&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2a13bbe7"

export default script